module.exports = __webpack_public_path__ + "static/media/HCMM092.dbcf074d.jpg";